import React, {Component} from 'react';
import SvgIconBaseComponent from '../../svgIconComponents/SvgIconBaseComponent';

export default class InfomationDisplayComponent extends Component {

    constructor(props){
        super(props);
        this.state = {

        }
    }    

    render() {
        const backgroundStyle = {
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            position:'fixed',
            top:0,
            left:0,
            right:0,
            bottom:0,
            zIndex:300,
        }

        const infoDisplayStyle = {
            maxWidth:'88%',
            padding:'24px',
            borderRadius:'12px',
            backgroundColor:'rgba(255,255,255,.9)',
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            flexFlow:'column'
        }

        const iconArea = {
            width:'48px',
            height:'48px',
        }

        const messageStyle = {
            fontSize:'18px',
            lineHeight:1.6,
            marginTop:'4px',
            textAlign:'center',
            whiteSpace:'pre-wrap'
        }

        return (
            <div style={backgroundStyle}>
              <div style={infoDisplayStyle}>
                <div style={iconArea}>
                  <SvgIconBaseComponent image={this.props.image} fillColor={this.props.fillColor} />
                </div>
                <div style={messageStyle}>{this.props.message}</div>
              </div>
            </div>
        )
    }

};

// Propsのデフォルト値
SvgIconBaseComponent.defaultProps = {
  image:'none',
  fillColor: '#555555',
  message:'',
};
